import React from 'react';

// Shared bits for the intake/screening surfaces (Admin → Intakes, ⌘K results)
// so an intake looks the same wherever it is listed.

export const INTAKE_TYPE_LABELS = { nda: 'NDA', grid: 'Grid', tprm: 'TPRM' };

const STATUS_TONE = {
  completed: { cls: 'green', label: 'Completed' },
  in_progress: { cls: 'blue', label: 'In progress' },
  abandoned: { cls: 'gray', label: 'Abandoned' },
};

export function intakeTypeLabel(typeKey) {
  return INTAKE_TYPE_LABELS[typeKey] || typeKey || '';
}

// Deliberately dot-less: matches how the Admin → Intakes table has always
// rendered these (unlike the review chips, which carry a status dot).
export function IntakeStatusChip({ status }) {
  const t = STATUS_TONE[status] || { cls: 'gray', label: status || 'Unknown' };
  return <span className={`chip ${t.cls}`}>{t.label}</span>;
}
